import React from "react";

const Reducer = (state, action) => {
  return <div></div>;
};

export default Reducer;
